document.querySelectorAll('.button-item__inner').forEach(btn => {
  btn.addEventListener('click', function(e) {
    const targetId = this.getAttribute('href').replace('#', '');
    const details = document.getElementById(targetId)?.querySelector('details');
    if (details && !details.open) {
      e.preventDefault(); // pour empêcher le scroll brut
      
      // Trouver tous les onglets déjà ouverts avant celui-ci
      const allDetails = document.querySelectorAll('details');
      let totalHeight = 0;
      
      for (const detail of allDetails) {
        if (detail.open && detail.getBoundingClientRect().top < details.getBoundingClientRect().top) {
          totalHeight += detail.offsetHeight;
        }
      }
      
      details.open = true;
      
      // Calculer la position de l'élément en soustrayant la hauteur des onglets ouverts
      const elementPosition = details.getBoundingClientRect().top + window.pageYOffset - totalHeight;
      
      // Faire défiler jusqu'à la position de l'élément
      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth'
      });
    }
  });
}); 